export default __webpack_public_path__ + "static/media/cif-ge.d275baa0.svg";